<template>
  <div>
    <Head :title="assessment.code" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/assessments">
        Assessment
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ assessment.code }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="confirmUpdate">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.code"
            :error="form.errors.code"
            :disabled="!canEdit"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input
            :model-value="assessment.assessment_status"
            class="pb-8 pr-6 w-full lg:w-1/2"
            input-class="font-bold"
            label="Status Assessment"
            disabled />
          <select-input
            v-model="form.donation_types_id"
            :error="form.errors.donation_types_id"
            :disabled="!canEdit || disabledInputInKind"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Jenis Bantuan">
            <option
              v-for="d in donationTypes"
              :key="d.id"
              :value="d.id">
              {{ d.name }}
            </option>
          </select-input>
          <template v-if="form.donation_types_id == 1">
            <select-input
              v-model="form.paket_m_id"
              :error="form.errors.paket_m_id"
              :disabled="!canEdit"
              class="pb-8 pr-6 w-full lg:w-1/2"
              label="Paket">
              <option
                v-for="d in packages"
                :key="d.id"
                :value="d.id">
                {{ d.name }}
              </option>
            </select-input>
            <number-input
              v-model="form.paket_qty"
              :error="form.errors.paket_qty"
              :disabled="!canEdit"
              class="pb-8 pr-6 w-full lg:w-1/2"
              input-class="text-right"
              label="Jumlah Paket" />
          </template>
          <number-input
            v-else
            v-model="form.nominal"
            :error="form.errors.nominal"
            :disabled="!canEdit"
            class="pb-8 pr-6 w-full lg:w-1/2"
            input-class="text-right"
            label="Nominal" />
          <select-input
            v-model="form.pr_id"
            :error="form.errors.pr_id"
            :disabled="!canEdit || disabledInputInKind"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Purchase Request">
            <option :value="null" disabled>
              -- Pilih Nomor PR terkait --
            </option>
            <option
              v-for="d in purchaseRequests"
              :key="d.id"
              :value="d.id">
              {{ d.code }}
            </option>
          </select-input>
          <text-input
            :model-value="assessment.total_qty_beneficiaries"
            class="pb-8 pr-6 w-full lg:w-1/2"
            input-class="text-right"
            label="Total Beneficiaries"
            disabled />
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            :disabled="!canEdit"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
        </div>
        <div class="-mr-6 px-8 py-4 border-t border-gray-100" id="attachments">
          <h3 class="text-xl">
            List berkas pendukung:
          </h3>

          <ul
            v-for="(docfile, idx) in assessment.files"
            :key="idx"
            class="w-full list-disc">
            <li class="flex gap-2 items-center">
              <span>- </span>
              <a
                :href="docfile.url"
                :class="attachmentAccess.download ? 'text-indigo-500 underline' : 'text-red-600'"
                target="_blank"
                :download="docfile.file_name"
                :disable="!attachmentAccess.download"> {{ docfile.file_name }}</a> ( {{ docfile.size }} )
              <a
                href=""
                title="Delete attachment file"
                @click.prevent="destroyAttachment(docfile.uuid)">
                <Icon icon="ic:baseline-delete-forever" class="w-6 h-6 text-red-600" />
              </a>
            </li>
          </ul>

          <file-input
            v-model="uploadForm.attachment"
            :error="uploadForm.errors.attachment"
            class="pr-6 py-4 w-full md:w-2/3"
            type="file"
            accept="image/*, application/pdf"
            label="Browse dan upload file dokumen pendukung (Max 10MB)"
            @update:model-value="uploadAttachment"
            v-if="attachmentAccess.upload" />
        </div>

        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
          <div class="flex items-center gap-4">
            <button
              v-if="canEdit"
              class="text-red-600 hover:underline"
              tabindex="-1"
              type="button"
              @click="confirmDelete">
              Delete Assessment
            </button>
          </div>
          <div class="flex items-center gap-4">
            <loading-button
              v-if="transitionAccess.publish"
              :loading="publishing"
              class="btn-indigo"
              type="button"
              @click="confirmPublish">
              Publish (PRE-ASSESSMENT)
            </loading-button>
            <loading-button
              v-if="canEdit"
              :loading="form.processing"
              class="btn-indigo"
              type="submit">
              Update Assessment
            </loading-button>
          </div>
        </div>
      </form>
    </div>

    <Modal v-model="confirmBox.show" :title="confirmBox.title">
      <p class="text-gray-600">
        {{ confirmBox.intro }}
      </p>
      <ul class="mt-3 space-y-1.5 text-sm text-gray-600 list-disc list-inside">
        <li v-for="(point, i) in confirmBox.points" :key="i">
          {{ point }}
        </li>
      </ul>
      <template #footer>
        <button
          type="button"
          class="px-4 py-2 text-gray-700 text-sm hover:bg-gray-100 rounded"
          @click="confirmBox.show = false">
          Batal
        </button>
        <loading-button
          :loading="confirmBox.kind === 'publish' ? publishing : form.processing"
          class="btn-indigo"
          type="button"
          @click="onConfirmBox">
          {{ confirmBox.confirmLabel }}
        </loading-button>
      </template>
    </Modal>

    <h2 class="mt-12 text-2xl font-bold">
      Beneficiary Families
    </h2>
    <div class="flex justify-between my-5">
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Family</span>
      </button>
    </div>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <family
          v-for="(family, idx) in families"
          :key="family.id"
          :row-index="++idx"
          :editable-mode="family.editable"
          :family-detail="family"
          :errors="$page.props.errors"
          @destroy:detail="destroyFamily"
          @edit:detail="editFamily"
          @cancel="cancel('edit')"
          @save="updateFamily" />
        <family
          v-if="createMode"
          :key="0"
          :editable-mode="createMode"
          :family-detail="editedItem"
          :errors="$page.props.errors"
          @cancel="cancel('create')"
          @save="createFamily" />
        <tr v-if="families?.length === 0">
          <td class="px-6 py-4 border-t" colspan="5">
            No beneficiary families found.
          </td>
        </tr>
      </table>
    </div>
    <div v-if="families?.length >= 1" class="flex justify-between my-5">
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Family</span>
      </button>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import NumberInput from '@/Shared/NumberInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal.vue'
import 'flatpickr/dist/flatpickr.css'
import Family from '@/Pages/Assessments/FamilyRow'
import mapValues from 'lodash/mapValues'
import find from 'lodash/find'
import { Icon } from '@iconify/vue'

export default {
    components: {
        Head,
        Link,
        Icon,
        LoadingButton,
        TextInput,
        TextareaInput,
        NumberInput,
        SelectInput,
        FileInput,
        Modal,
        Family,
    },
    layout: Layout,
    props: {
        assessment: Object,
        families: Array,
        donationTypes: Array,
        packages: Array,
        purchaseRequests: Array,
        attachmentAccess: Object,
        transitionAccess: Object,
        canEdit: {
            type: Boolean,
            default: false,
        },
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                code: this.assessment.code,
                donation_types_id: this.assessment.donation_types_id,
                nominal: this.assessment.nominal,
                paket_m_id: this.assessment.paket_m_id,
                paket_qty: this.assessment.paket_qty,
                total_qty_beneficiaries: this.assessment.total_qty_beneficiaries,
                pr_id: this.assessment.pr_id,
                desc: this.assessment.desc,
            }),
            uploadForm: this.$inertia.form({
                attachment: null,
            }),
            publishing: false,
            createMode: false,
            confirmBox: {
                show: false,
                kind: null,
                title: '',
                intro: '',
                points: [],
                confirmLabel: '',
            },
            editedItem: {
                id: null,
                assessment_m_id: null,
                head_name: null,
                head_kk_num: null,
                qr_code: null,
                location_address: null,
                deleted_at: null,
                editable: false,
            },
            detailKeyRefresh: 0,
        }
    },
    computed: {
        disabledInputInKind () {
            return this.form.donation_types_id === 1
        },
    },
    watch: {
        'form.paket_m_id' (newVal) {
            const selectedPackage = this.packages.find((p) => p.id === newVal)
            if (selectedPackage && selectedPackage.purchase_request_id) {
                this.form.pr_id = selectedPackage.purchase_request_id
            } else {
                this.form.pr_id = null
            }
        },
    },
    methods: {
        openConfirmBox ({ kind, title, intro, points, confirmLabel }) {
            this.confirmBox = { show: true, kind, title, intro, points, confirmLabel }
        },
        onConfirmBox () {
            if (this.confirmBox.kind === 'update') this.update()
            if (this.confirmBox.kind === 'publish') this.publish()
            if (this.confirmBox.kind === 'delete') this.destroy()
        },
        confirmUpdate () {
            this.openConfirmBox({
                kind: 'update',
                title: 'Simpan Perubahan Assessment',
                intro: `Simpan perubahan pada assessment ${this.assessment.code}?`,
                confirmLabel: 'Ya, Simpan',
                points: [
                    'Perubahan hanya disimpan di aplikasi yeu-logistik ini, belum terkirim ke aplikasi YEU-Assessment.',
                    'Ini kesempatan terakhir mengubah isian formulir. Setelah diterbitkan, formulir menjadi read-only dan perubahan data mengikuti proses assessment.',
                ],
            })
        },
        confirmPublish () {
            this.openConfirmBox({
                kind: 'publish',
                title: 'Terbitkan Assessment',
                intro: `Terbitkan assessment ${this.assessment.code}?`,
                confirmLabel: 'Ya, Terbitkan',
                points: [
                    'Status akan berubah dari DRAFT menjadi PRE-ASSESSMENT. Status hanya bergerak maju dan tidak bisa kembali ke DRAFT.',
                    'Data assessment akan terkirim ke aplikasi YEU-Assessment.',
                    'Team leader dan admin bisa mengaitkan assessment ini di aplikasi YEU-Assessment. Petugas lapangan bisa mengaitkan setelah status mencapai COLLECTING.',
                    'Jika pengiriman ke aplikasi gagal, status otomatis kembali ke DRAFT sehingga Anda bisa mencoba lagi.',
                ],
            })
        },
        confirmDelete () {
            this.openConfirmBox({
                kind: 'delete',
                title: 'Hapus Assessment',
                intro: `Hapus assessment ${this.assessment.code}?`,
                confirmLabel: 'Ya, Hapus',
                points: [
                    'Assessment akan masuk ke tong sampah dan hilang dari daftar assessment.',
                    'Assessment berstatus DRAFT belum pernah terkirim ke aplikasi YEU-Assessment, jadi penghapusan hanya berlaku di yeu-logistik.',
                    'Penghapusan tidak bisa dibatalkan dari halaman ini.',
                ],
            })
        },
        update () {
            this.form.post(`/assessments/${this.assessment.id}`, {
                preserveScroll: true,
                onFinish: () => {
                    this.confirmBox.show = false
                },
            })
        },
        uploadAttachment () {
            if (!this.uploadForm.attachment) return
            this.uploadForm.post(`/assessments/${this.assessment.id}/attachment`, {
                preserveScroll: true,
                onSuccess: () => this.uploadForm.reset('attachment'),
            })
        },
        publish () {
            this.publishing = true
            this.$inertia.post(`/assessments/${this.assessment.id}/transition`, {}, {
                preserveScroll: true,
                onFinish: () => {
                    this.publishing = false
                    this.confirmBox.show = false
                },
            })
        },
        destroyAttachment (uuid) {
            if (confirm('Are you sure you want to delete this attachment file?')) {
                this.$inertia.delete(`/attachment/${uuid}`)
            }
        },
        destroy () {
            this.$inertia.delete(`/assessments/${this.assessment.id}`)
        },
        restore () {
            if (confirm('Are you sure you want to restore this assessment?')) {
                this.$inertia.put(`/assessments/${this.assessment.id}/restore`)
            }
        },
        reset () {
            this.searchform = mapValues(this.searchform, () => null)
        },
        editFamily (family) {
            let edited = find(this.families, ['id', family.id])
            edited.editable = true
        },
        destroyFamily (familyId) {
            this.$inertia.delete(`/assessments/${this.assessment.id}/families/${familyId}`)
        },
        resetEditedItem () {
            this.editedItem = {
                id: null,
                assessment_m_id: null,
                head_name: null,
                head_kk_num: null,
                qr_code: null,
                location_address: null,
                editable: false,
            }
            this.createMode = false
        },
        cancel (action) {
            if (action === 'create') this.resetEditedItem()
            if (action === 'edit') this.$inertia.reload({ only: ['families'] })
        },
        createFamily (value) {
            const formFamily = this.$inertia.form({
                assessment_m_id: this.assessment.id,
                head_name: value.head_name,
                head_kk_num: value.head_kk_num,
                qr_code: value.qr_code,
                location_address: value.location_address,
            })
            formFamily.post(`/assessments/${this.assessment.id}/families`, {
                preserveScroll: true,
                onSuccess: () => {
                    this.resetEditedItem()
                },
                onError: () => {
                    this.editedItem = value
                },
            })
        },
        updateFamily (value) {
            const formFamily = this.$inertia.form({
                assessment_m_id: this.assessment.id,
                head_name: value.head_name,
                head_kk_num: value.head_kk_num,
                qr_code: value.qr_code,
                location_address: value.location_address,
            })
            formFamily.put(`/assessments/${this.assessment.id}/families/${value.id}`, {
                preserveScroll: true,
                onError: () => {
                    this.editedItem = value
                },
            })
        },
    },
}
</script>
